module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.3@core-js/library/modules/_redefine.js
// module id = 185
// module chunks = 0 1